import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import Header from "../commun/Header";
import DashboardBody from "../../pages/Dashboard/DashboardBody";

const Dashboard = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  return (
        <Box sx={{ display: "flex", height: "100vh" }}>
        <Header isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
            <Box sx={{ flex: 1, overflow: "auto", p: 3 }}>
                <DashboardBody />
            </Box>
        </Box>
  );
};

export default Dashboard;
